import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CommonCostFormRoutingModule } from "./common-cost-form-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { CommonCostFormComponent } from "./common-costing-form.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { MatCardModule } from "@angular/material/card";

@NgModule({
  declarations: [CommonCostFormComponent],
  imports: [
    CommonModule,
    CommonCostFormRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatTableModule,
    MatInputModule,
    MatPaginatorModule,
    MatDialogModule,
    MatSortModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSortModule,
    NgxSpinnerModule,
    MatCardModule
  ],
  exports: [CommonCostFormComponent]
})

export class CommonCostFormModule { }